module.exports = __webpack_public_path__ + "static/media/company3@3x.bd36dd7f.png";